export { default } from "@casino/external/icons/GenericTrophy";
